import React from 'react';
import { services } from '../data/services';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <SectionHeading row title="Services We Deliver" text="We deliver smart, scalable digital solutions tailored for your business. Our technology simplifies operations and drives sustainable growth." />
        <div className="grid grid--4">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 70}>
              <article className="card service">
                <span className="service__icon"><Icon name={s.icon} size={22} /></span>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
